export default {
  title: 'Ohjeet ja UKK',
  buttons: {
    faqs: 'UKK',
    contact_us: 'Ota yhteyttä',
  },
};
